import { render, staticRenderFns } from "./VisionMission.vue?vue&type=template&id=53ce7620&scoped=true&"
import script from "./VisionMission.vue?vue&type=script&lang=js&"
export * from "./VisionMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce7620",
  null
  
)

export default component.exports